import { useMutation } from 'react-query';
import {
    CreateUpdateMaterialityQuestion,
    MaterialityQuestion,
} from './materialityQuestionsTypes';
import { updateMaterialityQuestion } from './materialityQuestionService';
import { modifyError } from 'utils/error-modifer-utils';
import { toast } from 'react-toastify';

type Props = {
    onError?: (error: Error) => void;
    onSuccess?: (data: MaterialityQuestion) => void;
};

export const useUpdateMaterialityQuestion = ({
    onSuccess = () => {},
    onError = () => {},
}: Props) => {
    const onErrorModified = (error: any) => {
        const errors = modifyError(error?.response?.data);
        if (errors) {
            for (const err of errors) {
                toast.error(err);
            }
        } else {
            toast.error('Internal error, please contact administrator');
        }

        if (onError) {
            onError(error);
        }
    };
    const mutation = useMutation(
        async (input: {
            id: string;
            request: CreateUpdateMaterialityQuestion;
        }) => await updateMaterialityQuestion(input.id, input.request),
        {
            onSuccess,
            onError: onErrorModified,
        }
    );

    return {
        mutate: mutation.mutate,
        isLoading: mutation.isLoading,
        error: mutation.error,
    };
};
